class EventBus {
  constructor() {
    this.events = {}
    this.queue = []
  }

  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = []
    }
    this.events[event].push(callback)

    this.queue = this.queue.filter(({ e, data }) => {
      if (e === event) {
        callback(data)
        return false
      }
      return true
    })
  }

  off(event, callback) {
    if (!this.events[event]) return
    this.events[event] = this.events[event].filter((cb) => cb !== callback)
  }

  emit(event, data) {
    if (!this.events[event] || this.events[event].length === 0) {
      console.warn(`[EventBus] нет подписчиков для "${event}", буферизуем`)
      this.queue.push({ e: event, data })
      return
    }

    this.events[event].forEach((callback) => callback(data))
  }
}

export const eventBus = new EventBus()
